module.exports = __webpack_public_path__ + "static/media/5-hybrid.c52d3dd6.png";